import { NgModule } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { EditorModule } from '@tinymce/tinymce-angular';
import localeFr from '@angular/common/locales/fr';
import { contentsRoutes } from './partners.route';
import { PartnersSearchComponent } from './partners-search/partners-search.component';
import { PartnersSearchResultComponent } from './partners-search/partners-search-result/partners-search-result.component';
import { PartnersSearchQueryComponent } from './partners-search/partners-search-query/partners-search-query.component';
import { PartnersSearchFacetsComponent } from './partners-search/partners-search-facets/partners-search-facets.component';
import { PartnersEditComponent } from './partners-edit/partners-edit.component';
import { SelectMarketDialogComponent } from './partners-edit/select-market-dialog/select-market-dialog.component';
import { ListRecipeComponent } from './partners-edit/list-recipe/list-recipe.component';
registerLocaleData(localeFr);

@NgModule({
  declarations: [
    PartnersSearchResultComponent,
    PartnersSearchComponent,
    PartnersSearchQueryComponent,
    PartnersSearchFacetsComponent,
    PartnersEditComponent,
    SelectMarketDialogComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(contentsRoutes),
    MatNativeDateModule,
    EditorModule,
    ListRecipeComponent,
  ],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'fr-FR' }],
})
export class PartnersModule {}
